import React from "react";

const Footer = () => (
  <section id="footer-section">
    <footer>
      <h3 id="contact-me">Contact Me</h3>
      <h6>Location: Tampa, FL</h6>
      <h6>
        Email:
        <a href="mailto:styler8807@gmail.com"> styler8807@gmail.com</a>
      </h6>
    </footer>
  </section>
);

export default Footer;
